import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import { headers } from "app/_helpers/requestHeaders";

/**
 * Centralized Axios instance for all HTTP requests
 * This allows us to configure axios behavior in one place
 * prepared for future use
 */
const axiosInstance: AxiosInstance = axios.create({
  // You can add default config here
  timeout: 30000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Request Interceptor
 * Add any custom logic before request is sent
 */
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // You can add custom logic here, e.g.:
    // - Add timestamps
    // - Log requests
    // - Modify headers dynamically

    // console.log(`[HTTP Request] ${config.method?.toUpperCase()} ${config.url}`);

    return config;
  },
  (error: AxiosError) => {
    console.error("[HTTP Request Error]", error);
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor
 * Add any custom logic after response is received
 */
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // You can add custom logic here, e.g.:
    // - Log responses
    // - Transform data
    // - Handle specific status codes

    // console.log(`[HTTP Response] ${response.status} ${response.config.url}`);

    return response;
  },
  (error: AxiosError) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with error status
      console.error(
        `[HTTP Error] ${error.response.status} ${error.config?.url}`,
        error.response.data
      );

      // You can handle specific error codes here
      switch (error.response.status) {
        case 401:
          // Handle unauthorized - maybe trigger token refresh
          console.warn("Unauthorized request - token may be expired");
          break;
        case 403:
          console.warn("Forbidden request");
          break;
        case 404:
          console.warn("Resource not found");
          break;
        case 500:
          console.error("Internal server error");
          break;
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error("[HTTP Error] No response received", error.request);
    } else {
      // Something else happened
      console.error("[HTTP Error]", error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
export { AxiosRequestConfig, AxiosResponse, AxiosError };
